import { useMemo } from 'react'
import FilterSkeleton from './FilterSkeleton'

interface FilterRowSkeletonProps {
  count?: number
  itemWidth?: number
  className?: string
}

const FilterRowSkeleton = ({ count = 4, itemWidth, className }: FilterRowSkeletonProps) => {
  const skeletonArray = useMemo(() => {
    return new Array(count).fill('')
  }, [count])

  return (
    <div data-testid="filter-row-skeleton" className={className}>
      {skeletonArray.map((_, idx) => (
        <FilterSkeleton width={itemWidth} key={idx} />
      ))}
    </div>
  )
}

export default FilterRowSkeleton
